@if (employeeCapacity()) {
  <div>
    <div class="footfall"
         [ngClass]="{'max-footfall': roundUp(maxFootfall()) === roundUp(employeeCapacity().footfall)}"
         [ngbTooltip]="tooltip">
      {{ roundUp(employeeCapacity().footfall) }} /
      {{ roundUp(employeeCapacity().recommendedEmployee) }}
    </div>
    @if (employeeCapacity().isUndercapacity()) {
      <div class="undercapacity-mark"></div>
    } @if (employeeCapacity().isOvercapacity()) {
    <div class="overcapacity-mark"></div>
  }
  </div>
}

<ng-template #tooltip>
  <div class="employee-tooltip">
    <p class="hour">
      {{ startHour() }} - {{ endHour() }}
    </p>
    <p class="calculated-footfall">
      Calculated footfall: {{ employeeCapacity().footfall.toFixed(2) }}
    </p>
    <p class="recommended-employee">
      Recommended employee: {{ employeeCapacity().recommendedEmployee.toFixed(2) }}
    </p>
    <p class="assigned-employee">
      Assigned employee: {{ employeeCapacity().assignedEmployee }}
    </p>
    @if (employeeCapacity().isOvercapacity()) {
      <p class="overcapacity">
        Overcapacity with
        {{ employeeCapacity().assignedEmployee - roundUp(employeeCapacity().recommendedEmployee) }}
        employees
      </p>
    } @if (employeeCapacity().isUndercapacity()) {
    <p class="undercapacity">
      Undercapacity with
      {{ roundUp(employeeCapacity().recommendedEmployee) - employeeCapacity().assignedEmployee }}
      employees
    </p>
  }
  </div>
</ng-template>